import { Slide, Dialog } from '@material-ui/core'
import { TransitionProps } from '@material-ui/core/transitions'
import React from 'react'

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} />
})

interface Props {
    open: boolean
    onClose: () => void
    children?: React.ReactNode
}

const FormDialog = (props: Props) => {
    const { onClose, open, children } = props
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={onClose}
            
        >
            {open && children}
        </Dialog>
    )
}

export default FormDialog
